export { QuizResultQuestionStem } from "./QuizResultQuestionStem";
